<template>
  <mdb-container fluid>
    <banner-small v-if="group" :group="group" :title="capitalize($tc('common.label.member',2))"/>
    <div v-if="group">

      <div class="text-left text-info mb-2" v-if="group.activeMemberCount > 1 && controls.showMemberList">
        <mdb-icon icon="lightbulb"></mdb-icon> {{group.name}} has {{ group.activeMemberCount }} {{group.memberLabel}}.
      </div>

      <data-table v-show="controls.showMemberList"
                  :actions="actions"
                  :additional-parameters="queryParams"
                  :force-query="forceQuery"
                  @handleAction="handleRowAction"
                  @forcedRowLoaded="forcedRowLoaded"
                  :show-add-button="(userDetails.isAdmin || userDetails.isTenantAdmin) || (settings.allowMemberCreation && group.role=='Admin')"
                  add-label="Add a New Member"
                  :add-handler="addMember"
                  queryName="MemberQuery"/>
    </div>

    <div v-if="controls.showMemberDetail && currentMember" class="text-left">
      <mdb-btn rounded @click="showList">
        <mdb-icon icon="arrow-left"></mdb-icon>
        List
      </mdb-btn>
      <section class="section team-section">
        <div class="row">
          <div class="col-md-4">
            <div class="card profile-card text-center mb-4 animated slideInDown">
              <div class="avatar mb-4">
                <avatar :avatar="currentMember.avatarLarge" :full="currentMember.avatarFull"
                        :reputation="currentMember.ribbon" containerClass=""/>
              </div>
              <div class="card-body pt-0 mt-0">
                <h3 class="mb-3 font-weight-bold"><strong>{{ currentMember.name }}</strong></h3>
                <h5 v-if="controls.ownerId == currentMember.userId" class="font-weight-bold cyan-text">
                  {{ capitalize($tc("common.label.group",1)) }} Owner</h5>
                <h5 v-if="currentMember.role != 'Member' && controls.ownerId != currentMember.userId"
                    class="font-weight-bold cyan-text">
                  {{ currentMember.role }}
                </h5>
                <h6 v-if="currentMember.title" class="font-weight-bold">{{ currentMember.title }}</h6>
                <div v-if="currentMember.intro || currentMember.groupReview">
                  <p class="font-weight-normal">
                    <mdb-icon class="pr-2" icon="quote-left"></mdb-icon>
                  </p>
                  <div v-html="currentMember.intro"/>
                  <div v-html="currentMember.groupReview"/>
                </div>
                <div class="action-buttons">
                  <mdb-tooltip
                    v-if="group.permissions.includes('Accounting') && (currentMember.status == 'Active' || currentMember.status == 'Pending')"
                    :options="{placement: 'top'}" material
                    trigger="hover">
                    <span slot="tip">Member's billing & payment tracking</span>
                    <mdb-btn slot="reference" floating icon="piggy-bank" size="sm"
                             tag="a"
                             type="" @click="showBilling">
                    </mdb-btn>
                  </mdb-tooltip>

                  <mdb-tooltip v-if="group.role=='Admin' && !currentMember.isOwner && currentMember.status == 'Active'"
                               :options="{placement: 'top'}" material
                               trigger="hover">
                    <span slot="tip">Control Member's Access</span>
                    <mdb-btn slot="reference" color="warning"
                             floating
                             icon="shield-check" size="sm" tag="a"
                             type=""
                             @click="controls.showAccess = true">
                    </mdb-btn>
                  </mdb-tooltip>

                  <mdb-tooltip
                    v-if="group.permissions.includes('Remove Members') && !currentMember.isOwner && currentMember.status != 'Denied' && currentMember.status != 'Banned'"
                    :options="{placement: 'top'}" material
                    trigger="hover">
                    <span slot="tip">Remove member from group</span>
                    <mdb-btn slot="reference" color="danger" floating icon="user-slash" size="sm"
                             tag="a"
                             type="" @click="controls.showRemove=true">
                    </mdb-btn>
                  </mdb-tooltip>
                  <mdb-tooltip v-if="currentMember.userId != userDetails.id && showPrivateMessage"
                               :options="{placement: 'top'}" material
                               trigger="hover">
                    <span slot="tip">Send private message</span>
                    <mdb-btn slot="reference" floating
                             icon="envelope" size="sm"
                             tag="a"
                             type="" @click="$router.push('/conversations/?start='+currentMember.userId)">
                    </mdb-btn>
                  </mdb-tooltip>

                </div>
              </div>
            </div>
            <mdb-card v-if="currentMember.id != group.memberId && togetherEvents.length > 0" class="animated slideInUp">
              <mdb-card-header class="text-center">
                <h4>You Attended With {{ currentMember.name }}</h4>
                <div v-if="togetherCount > togetherEvents.length" class="small">
                  Showing {{ togetherEvents.length }} of {{ togetherCount }} total
                </div>

              </mdb-card-header>
              <mdb-card-body>
                <mdb-list-group>
                  <mdb-list-group-item v-for="(t,i) in togetherEvents" v-bind:key="i">
                    <router-link :to="'/event/show/' + t.id">{{ t.title }} on {{ t.date }}</router-link>
                  </mdb-list-group-item>
                </mdb-list-group>

              </mdb-card-body>
            </mdb-card>
          </div>

          <div class="col-md-8 mb-4 animated slideInUp">
            <mdb-card v-if="currentMember && currentMember.status == 'Pending'" class="mb-4">
              <mdb-card-header class="warning-color text-muted"><h4>Join Request Pending</h4></mdb-card-header>
              <mdb-card-body>
                <p>{{ currentMember.name }} wants to join.</p>
                <mdb-btn icon="user-plus" @click="approve"> Approve</mdb-btn>
                <mdb-input v-model="denyReason" placeholder="Denied Reason (user will see this), Optional."></mdb-input>
                <mdb-btn color="danger" icon="user-minus" @click="deny"> Deny</mdb-btn>
              </mdb-card-body>
            </mdb-card>

            <mdb-card v-if="currentMember && currentMember.status == 'Suspended'" class="mb-4">
              <mdb-card-header class="danger-color text-light"><h4>Suspended</h4></mdb-card-header>
              <mdb-card-body>
                <p>{{ currentMember.name }} is currently suspended.
                  <span v-if="currentMember.suspendedReason">Reason: {{ currentMember.suspendedReason }}</span>
                </p>
                <mdb-btn icon="user-plus" @click="reinstate"> Reinstate</mdb-btn>
              </mdb-card-body>
            </mdb-card>

            <mdb-card v-if="currentMember && currentMember.status == 'Denied'" class="mb-4">
              <mdb-card-header class="danger-color text-light"><h4>Denied</h4></mdb-card-header>
              <mdb-card-body>
                <p>{{ currentMember.name }} has been denied.
                  <span v-if="currentMember.denyReason">Reason: {{ currentMember.denyReason }}</span>
                </p>
                <mdb-btn icon="user-plus" @click="reinstate"> Approve</mdb-btn>
              </mdb-card-body>
            </mdb-card>

            <mdb-card v-if="currentMember && currentMember.status == 'Banned'" class="mb-4">
              <mdb-card-header class="danger-color text-light"><h4>Banned</h4></mdb-card-header>
              <mdb-card-body>
                <p>{{ currentMember.name }} is currently banned.
                </p>
                <div v-if="group.permissions.includes('Remove Members')">
                  <mdb-btn icon="user-plus" @click="unban"> Un-ban</mdb-btn>
                  <p class="small">Unbanning someone will make them a member of the group.</p>
                </div>
              </mdb-card-body>
            </mdb-card>

            <mdb-card class="mb-4">
              <mdb-card-header><h4>Stats</h4></mdb-card-header>
              <mdb-card-body>
                <mdb-input v-model="currentMember.joined" disabled label="Joined"/>
                <mdb-input v-model="currentMember.city" disabled label="City"/>
                <mdb-input v-model="currentMember.lastVisited" disabled label="Last Visited"/>
                <mdb-input v-if="currentMember.attended>0" v-model="currentMember.attended" disabled
                           :label="capitalize($tc('common.label.event',1)) + ' ' + capitalize($t('common.label.attended'))"/>
                <mdb-input v-if="currentMember.hosted>0" v-model="currentMember.hosted" disabled
                           :label="capitalize($tc('common.label.event',2)) + ' ' + capitalize($t('common.label.hosted'))"/>
                <mdb-input v-if="currentMember.noshow>0" v-model="currentMember.noshow" disabled label="No Shows"/>
                <mdb-input v-if="currentMember.lateCancels>0" v-model="currentMember.lateCancels" disabled
                           label="Late Cancellations"/>
                <div v-if="group.reputationEnabled" class="text-left">
                  <mdb-input v-model="currentMember.reputationDisplay" :label="controls.reputationLabel + ' Score'"
                             disabled/>
                  <a href="#" @click="repRules">See {{ group.name }} {{ controls.reputationLabel }} rules</a>
                </div>
                <mdb-input v-if="currentMember.lastEvent" v-model="currentMember.lastEvent" disabled
                           :label="'Last ' + capitalize($tc('common.label.event',1)) + ' Attended'"/>
                <mdb-input v-if="currentMember.nextEvent" v-model="currentMember.nextEvent" disabled
                           :label="'Next '+ capitalize($tc('common.label.event',1)) + ' Attending'"/>
                <mdb-btn v-if="group.role=='Admin' || group.role=='Group Organizer'"
                         icon="clock"
                         rounded size="sm"
                         @click="$router.push('/member/' + currentMember.id + '/events')">{{$tc('common.label.event',1) }} History
                </mdb-btn>
              </mdb-card-body>
            </mdb-card>
            <mdb-card class="mb-4">
              <mdb-card-header>
                <h4>Additional Data</h4>
              </mdb-card-header>
              <mdb-card-body>
                <custom-data :custom-data="currentMember.tracking" :allow-edit="group.permissions.includes('Data Edit')"
                             @dataSaved="customDataSaved"/>
              </mdb-card-body>
            </mdb-card>
            <mdb-card v-if="group.permissions.includes('Member Notes')" class="mb-4">
              <mdb-card-header>
                <h4>Notes
                  <mdb-btn aria-label="Edit Notes" class="fa-pull-right" rounded size="sm" title="Edit Notes"
                           icon="pencil" floating tag="a"
                           @click="editNotes">
                  </mdb-btn>
                </h4>
              </mdb-card-header>
              <mdb-card-body>
                <div v-html="memberNotes"></div>
              </mdb-card-body>
            </mdb-card>
          </div>
        </div>
      </section>
    </div>

    <mdb-modal v-if="showAddDialog" @close="showAddDialog = false">
      <mdb-modal-header class="secondary-color text-white" :close="true">
        <h4>Who would you like to add?</h4>
      </mdb-modal-header>
      <mdb-modal-body>
        <mdb-btn @click="addExistingUser" style="width:75%">
          <mdb-icon icon="user"/>
          An Existing Platform User
        </mdb-btn>
        <mdb-btn @click="addUser" style="width:75%">
          <mdb-icon icon="user-plus"/>
          Create a New User
        </mdb-btn>
      </mdb-modal-body>
    </mdb-modal>

    <mdb-modal v-if="controls.showNotes && currentMember" @close="cancelNotes">
      <mdb-modal-header :close="true">
        Notes about {{ currentMember.name }}
      </mdb-modal-header>
      <mdb-modal-body>
        <editor v-model="workingEdit" :init="editorConfig">
        </editor>
        <mdb-btn @click="saveNotes">
          <mdb-icon icon="save"/>
          Save
        </mdb-btn>
        <mdb-btn @click="cancelNotes">
          <mdb-icon icon="window-close"/>
          Cancel
        </mdb-btn>
      </mdb-modal-body>
    </mdb-modal>

    <mdb-modal v-if="showReputationModal" @close="showReputationModal = false">
      <mdb-modal-header :close="true" class="primary-color text-white">
        {{ group.name }} {{ group.reputationLabel }} Rules
      </mdb-modal-header>
      <mdb-modal-body>
        <mdb-tabs :active="0" :links="[ {text:'Earning'}, {text:'Levels'}]" :transition-duration="0.5" card
                  class="mb-5"
                  tabs
                  transition-style="linear"
        >
          <div :slot="'Earning'" class="text-left">
            <mdb-tbl striped>
              <mdb-tbl-head class="secondary-color text-white">
                <tr>
                  <th><b>How</b></th>
                  <th><b>Points</b></th>
                </tr>
              </mdb-tbl-head>
              <mdb-tbl-body>
                <tr>
                  <td>Attend an Event</td>
                  <td class="text-right">{{ reputationRules.attendanceScore }}</td>
                </tr>
                <tr>
                  <td>Host an Event</td>
                  <td class="text-right">{{ reputationRules.hostingScore }}</td>
                </tr>
                <tr>
                  <td>No Show to an Event</td>
                  <td class="text-right">{{ reputationRules.noShowScore }}</td>
                </tr>
                <tr>
                  <td>Late Cancellation</td>
                  <td class="text-right">{{ reputationRules.lateCancelScore }}</td>
                </tr>
              </mdb-tbl-body>
            </mdb-tbl>
          </div>
          <div :slot="'Levels'" class="text-left">
            <mdb-tbl striped>
              <mdb-tbl-head class="secondary-color text-white">
                <tr>
                  <th><b>Level</b></th>
                  <th><b>Achieved With # Points</b></th>
                </tr>
              </mdb-tbl-head>
              <mdb-tbl-body>
                <tr>
                  <td>
                    <avatar :avatar="reputationRules.emptyAvatar" :size="35" reputation="gold"/>
                    Gold
                  </td>
                  <td>{{ reputationRules.goldLevel }}</td>
                </tr>
                <tr>
                  <td>
                    <avatar :avatar="reputationRules.emptyAvatar" :size="35" reputation="silver"/>
                    Silver
                  </td>
                  <td>{{ reputationRules.silverLevel }}</td>
                </tr>
                <tr>
                  <td>
                    <avatar :avatar="reputationRules.emptyAvatar" :size="35" reputation="bronze"/>
                    Bronze
                  </td>
                  <td>{{ reputationRules.bronzeLevel }}</td>
                </tr>
                <tr>
                  <td>
                    <avatar :avatar="reputationRules.emptyAvatar" :size="35" reputation="green"/>
                    Green
                  </td>
                  <td>{{ reputationRules.greenLevel }}</td>
                </tr>
                <tr>
                  <td>
                    <avatar :avatar="reputationRules.emptyAvatar" :size="35" reputation="empty"/>
                    None
                  </td>
                  <td>0</td>
                </tr>
                <tr>
                  <td>
                    <avatar :avatar="reputationRules.emptyAvatar" :size="35" reputation="red"/>
                    Warning
                  </td>
                  <td>Less than 0</td>
                </tr>
              </mdb-tbl-body>
            </mdb-tbl>
          </div>
        </mdb-tabs>

        <mdb-btn @click="showReputationModal=false">
          <mdb-icon icon="window-close"/>
          Close
        </mdb-btn>
      </mdb-modal-body>
    </mdb-modal>

    <mdb-modal v-if="controls.showRemove && currentMember" @close="controls.showRemove = false">
      <mdb-modal-header :close="true" class="secondary-color text-white">
        <h5>Remove {{ currentMember.name }}</h5>
      </mdb-modal-header>
      <mdb-modal-body>

        <mdb-btn color="warning" icon="user-slash" @click="removeConfirm('remove')">
          Remove {{ currentMember.name }}
        </mdb-btn>

        <mdb-btn color="danger" icon="user-slash" @click="removeConfirm('ban')">
          Ban {{ currentMember.name }}
        </mdb-btn>

        <hr>

        <mdb-input v-model="suspendReason" placeholder="Suspend Reason (member will see this), Optional."></mdb-input>
        <mdb-btn class="mb-4" color="blue" icon="clock" @click="doSuspend">
          Suspend {{ currentMember.name }}
        </mdb-btn>

        <div class="text-left small">
          <p><b>Remove</b> will take the member off your {{ $tc('common.label.member',1) }} list, but they may
            request joining again in the future.</p>
          <p><b>Ban</b> will take the member off your {{ $tc('common.label.member',1) }} list and also
            <b><i>prevent</i></b> them from
            joining in the future.</p>
          <p><b>Suspend</b> will not take the {{ $tc('common.label.member',1) }} off your list, but they will have
            limited
            access to {{ $tc('common.label.group',1) }} features and may not join {{ $tc('common.label.event',2) }}.
            You can reinstate a suspended {{ $tc('common.label.member',1) }} at any time.</p>
          <p>Once removed, you may not add a {{ $tc('common.label.member',1) }} back yourself. You may remove someone
            from the
            banned list, but this will not re-join them to the {{ $tc('common.label.group',1) }}.</p>
        </div>
      </mdb-modal-body>
    </mdb-modal>
    <mdb-modal v-if="confirmRemoveModal" :show="confirmRemoveModal" class="text-center"
               danger size="sm" @close="confirmRemoveModal = false">
      <mdb-modal-header :close="false" center>
        <p class="heading">Are you sure you wish to {{ removeMode }} {{ currentMember.name }}?</p>
      </mdb-modal-header>
      <mdb-modal-body>
        <mdb-icon class="animated rotateIn" icon="times" size="4x"/>
      </mdb-modal-body>
      <mdb-modal-footer center>
        <mdb-btn outline="danger" @click="doRemove">Yes</mdb-btn>
        <mdb-btn @click="confirmRemoveModal = false">No</mdb-btn>
      </mdb-modal-footer>
    </mdb-modal>

    <mdb-modal v-if="controls.showAccess" :show="controls.showAccess" class="text-center"
               @close="controls.showAccess = false">
      <mdb-modal-header :close="true" class="secondary-color text-white">
        <h5>Access for {{ currentMember.name }}</h5>
      </mdb-modal-header>
      <mdb-modal-body>
        <member-access :group="group" :member="currentMember"/>
      </mdb-modal-body>
    </mdb-modal>

    <div v-if="controls.showBilling" class="text-left">
      <mdb-btn rounded @click="doneBilling">
        <mdb-icon icon="arrow-left"></mdb-icon>
        {{ currentMember.name }}'s Profile
      </mdb-btn>

      <member-billing :group="group" :member="currentMember"/>
    </div>

    <mdb-modal v-if="existingUserModal" @close="existingUserModal=false" size="lg">
      <mdb-modal-header class="secondary-color"><h5>Add Existing User</h5></mdb-modal-header>
      <mdb-modal-body>
        <mdb-input v-model="existingSearch" label="Find User"
                   @keydown.native="watchForEnter"
                   placeholder="Search"
                   id="existing-search"
                   type="text"></mdb-input>
        <mdb-tbl striped responsive>
          <mdb-tbl-body>
            <tr v-for="f in foundUsers" :key="f.id" class="text-left">
              <td style="width:75%">
                <avatar :avatar="f.avatar" :size="50" containerClass=""/>
                {{ f.name }} - {{ f.email }}
              </td>
              <td style="width:25%">
                <mdb-btn size="sm" rounded icon="check" @click="existingSelected(f)">Add to
                  {{ $tc('common.label.group',1) }}
                </mdb-btn>
              </td>
            </tr>
          </mdb-tbl-body>
        </mdb-tbl>
        <mdb-btn size="sm" rounded icon="search" @click="doExistingSearch">Search</mdb-btn>
        <mdb-btn size="sm" rounded icon="ban" @click="existingUserModal=false">Cancel</mdb-btn>

      </mdb-modal-body>
    </mdb-modal>

    <mdb-modal v-if="addUserModal" @close="addUserModal=false">
      <mdb-modal-header class="secondary-color"><h4>Create New System User</h4></mdb-modal-header>
      <mdb-modal-body>
        <mdb-input v-model="newUser.name" label="Name"
                   placeholder="Name"
                   type="text"></mdb-input>
        <mdb-input v-model="newUser.email"
                   label="Email"
                   placeholder="someone@example.com" type="text"></mdb-input>
        <mdb-btn v-if="newUser.name && newUser.email" icon="save" @click="saveNewUser">Save</mdb-btn>
        <mdb-btn icon="ban" @click="addUserModal=false">Cancel</mdb-btn>
        <div class="text-info small">Adding a new {{ $tc('common.label.member',1) }} will not notify them. Use this
          feature for people
          who don't regularly use online systems, but you need to maintain a record of them. Use the invite feature
          for people you wish to notify and let them create their own account.
        </div>
      </mdb-modal-body>
    </mdb-modal>

  </mdb-container>
</template>

<script>
import api from '../../services/groupsPlaceApi.js'
import editor from '@tinymce/tinymce-vue'
import memberAccess from './MemberAccess'
import memberBilling from './MemberBilling'
import {
  mdbBadge,
  mdbBtn,
  mdbCard,
  mdbCardBody,
  mdbCardFooter,
  mdbCardGroup,
  mdbCardHeader,
  mdbCardImage,
  mdbCardText,
  mdbCardTitle,
  mdbCol,
  mdbContainer,
  mdbIcon,
  mdbInput,
  mdbListGroup,
  mdbListGroupItem,
  mdbMask,
  mdbModal,
  mdbModalBody,
  mdbModalFooter,
  mdbModalHeader,
  mdbRow,
  mdbSelect,
  mdbTabs,
  mdbTbl,
  mdbTblBody,
  mdbTblHead,
  mdbTooltip,
  mdbView,
} from 'mdbvue';
import BannerSmall from "./BannerSmall"
import Avatar from "../common/Avatar"
import {Datetime} from 'vue-datetime'
import CustomData from "../common/CustomData"
import utils from "../../services/utils"
import DataTable from "../common/DataTableAdvanced";

export default {
  name: 'Members',
  components: {
    BannerSmall,
    mdbContainer,
    mdbCardGroup,
    mdbCard,
    mdbCardHeader,
    mdbCardBody,
    mdbCardFooter,
    mdbCardTitle,
    mdbCardText,
    mdbCardImage,
    mdbIcon,
    mdbInput,
    mdbView,
    mdbMask,
    mdbBtn,
    mdbRow,
    mdbListGroup,
    mdbListGroupItem,
    mdbCol,
    mdbModal,
    mdbModalHeader,
    mdbModalBody,
    mdbModalFooter,
    mdbSelect,
    mdbTooltip,
    mdbBadge,
    mdbTbl,
    mdbTblHead,
    mdbTblBody,
    mdbTabs,
    Avatar,
    Datetime,
    editor,
    memberAccess,
    memberBilling,
    CustomData,
    DataTable
  },
  data() {
    return {
      members: [],
      suspendReason: "",
      currentMember: null,
      togetherEvents: [],
      togetherCount: null,
      workingEdit: null,
      memberNotes: null,
      confirmRemoveModal: false,
      removeMode: "",
      denyReason: "",
      showPrivateMessage: false,
      controls: {
        format: "",
        showMemberList: true,
        showMemberStats: false,
        showMemberDetail: false,
        showViewSelection: false,
        showAccess: false,
        showNotes: false,
        showDeny: false,
        showBilling: false,
        editTracking: false,
        showRemove: false,
        showSearch: true,
        lastList: "mostActive",
        listScrollPos: 0,
        listTitle: "...",
        listCount: 0,
        pendingApproval: 0,
        ownerId: 0,
        singleSelect: 0,
        button: "",
        showAddPlan: false,
        showAddTransaction: false,
        transactionsLoading: false,
        noPlans: false
      },
      showAddDialog: false,
      addUserModal: false,
      existingUserModal: false,
      newUser: null,
      foundUsers: [],
      editorConfig: {
        browser_spellcheck: true,
        branding: false,
        plugins: ["link", "code", "paste", "table", "lists"],
        toolbar: ["undo redo cut copy paste bold italic underline numlist bullist fontsizeselect | alignleft alignright aligncenter | link unlink code "],
        style_formats_merge: true,
        paste_as_text: true,
        relative_urls: false,
        remove_script_host: false,
        height: 400
      },
      reputationRules: null,
      showReputationModal: false,
      enteredFromPath: null,
      existingSearch: "",
      actions: [{name: "view", label: "View Details", class: 'text-success', color: "success", icon: "clipboard"}],
      forceQuery: null,
      queryParams: {}
    }
  },
  beforeRouteEnter(to, from, next) {
    console.log("Entering from ", from)
    next(vm => {
      if (from && from.path) vm.enteredFromPath = from.path
    })
  },
  beforeRouteLeave(to, from, next) {
    console.log("To", to.path, " FROM ", this.enteredFromPath)
    if (to.path != this.enteredFromPath) {
      //not the back button, so go where they want!
      next()
      return
    }

    if (this.$route.params.member) {
      next()
      return
    }
    if (to.name == "member-events" || to.name == "conversations") {
      next()
      return
    }

    if (this.controls.showMemberDetail) {
      if (this.controls.showAccess) {
        this.controls.showAccess = false
        next(false)
        return
      }
      if (this.controls.showRemove) {
        this.controls.showRemove = false
        next(false)
        return
      }
      if (this.controls.editTracking) {
        this.cancelTracking()
        next(false)
        return
      }
      if (this.controls.showNotes) {
        this.cancelNotes()
        next(false)
        return
      }


      next(false)
      this.controls.showMemberDetail = false
      this.controls.showBilling = false
      this.controls.showMemberList = true
      this.currentMember = null
      return
    }
    if (this.controls.showBilling) {
      this.doneBilling()
      next(false)
      return
    }

    next()
  },
  computed: {
    group: function () {
      return this.$store.state.currentGroup
    },
    userDetails: function () {
      return this.$store.state.userDetails
    },
    settings: function () {
      return this.$store.state.settings
    }
  },
  async mounted() {
    document.title = utils.capitalize( this.$tc('common.label.member',1) )
    this.queryParams.group = this.$route.params.id
    await this.$store.dispatch("setExecuting", true)
    await api.groupBasics(this.$route.params.id, "member")
    if (!this.group) {
      await this.$store.dispatch("setExecuting", false)
      await this.$router.push({path: '/403', query: {redirect: this.$route.fullPath}})
      return
    }
    await this.$store.dispatch("setExecuting", false)
    if (this.group.reputationEnabled) {
      this.controls.listType = "reputation"
      this.controls.reputationLabel = this.group.reputationLabel
    }
    api.trackGroupVisit(this.$route.params.id)

    if (this.$route.params.member) {
      this.forceQuery = "id:" + this.$route.params.member
    } else if (this.$route.query.view) {
      this.forceQuery = "view:" + this.$route.query.view
    }

  },
  methods: {
    forcedRowLoaded(row) {
      this.memberDetails(row)
    },
    handleRowAction(row, action) {
      if (action == "view") {
        this.controls.listScrollPos = window.scrollY
        this.memberDetails(row)
      }
    },
    addMember() {
      this.showAddDialog = true
    },
    addUser() {
      this.showAddDialog = false
      this.newUser = {name: "", email: "", groupId: this.group.id}
      this.addUserModal = true
    },
    addExistingUser() {
      this.showAddDialog = false
      this.existingUserModal = true
      this.foundUsers = []
      this.$nextTick().then(() => {
        let el = document.getElementById("existing-search")
        if (el) el.focus()
      })
    },
    watchForEnter: function (k) {
      if (k.keyCode == 13 && this.existingSearch != "") this.doExistingSearch()
    },
    doExistingSearch: function () {
      let url = "/user/list?q=" + this.existingSearch + "&max=10&offset=0"
      this.$store.dispatch("setExecuting", true)
      api.get(url).then(
        (results) => {
          this.foundUsers = results.data.rows
        },
        (error) => {
          this.$notify.error({message: error.response.data})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },
    existingSelected(u) {
      this.existingUserModal = false
      this.$store.dispatch("setExecuting", true)
      api.post("/member/createExisting", {groupId: this.group.id, userId: u.id}).then(
        (results) => {
          let member = {id: results.data.id}
          this.memberDetails(member)
        },
        (error) => {
          this.$notify.error({message: error.response.data, timeOut: 5000})
          this.existingUserModal = true
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },
    saveNewUser() {
      this.addUserModal = false
      this.$store.dispatch("setExecuting", true)
      api.post("/member/create", this.newUser).then(
        (results) => {
          let member = {id: results.data.id}
          this.memberDetails(member)
        },
        (error) => {
          this.$notify.error({message: "Error saving data", timeOut: 5000})
          this.addUserModal = true
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },
    showBilling: function () {
      this.controls.showMemberDetail = false
      this.controls.showBilling = true
    },
    doneBilling: function () {
      this.controls.showMemberDetail = true
      this.controls.showBilling = false
    },
    switchView: function (view) {
      this.controls.listType = view
      this.controls.searching = false
      this.controls.showViewSelection = false
    },
    removeConfirm(mode) {
      this.controls.showRemove = false
      this.confirmRemoveModal = true
      this.removeMode = mode
    },
    customDataSaved(data) {
      this.$store.dispatch("setExecuting", true)
      api.post("/member/dataTrack/" + this.group.vanityPath + "/?member=" + this.currentMember.id, data).then(
        (results) => {
          this.currentMember.tracking = results.data
        },
        (error) => {
          this.$notify.error({message: "Error saving data", timeOut: 5000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },
    doRemove() {
      this.confirmRemoveModal = false
      let idx = this.members.indexOf(this.currentMember)
      this.$store.dispatch("setExecuting", true)
      api.post("/member/" + this.removeMode + "/" + this.group.vanityPath + "/?member=" + this.currentMember.id, {}).then(
        (results) => {
          if (this.removeMode == 'ban') {
            this.currentMember.status = "Banned"
          } else {
            this.controls.showMemberDetail = false
            this.controls.showMemberList = true
            this.currentMember = null
            this.members.splice(idx, 1)
          }
        },
        (error) => {
          this.$notify.error({message: "Error saving data", timeOut: 5000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },
    doSuspend() {
      this.controls.showRemove = false
      this.$store.dispatch("setExecuting", true)
      api.post("/member/suspend/" + this.group.vanityPath + "/?member=" + this.currentMember.id, {reason: this.suspendReason}).then(
        (results) => {
          this.currentMember.status = "Suspended"
          this.currentMember.suspendedReason = this.suspendReason
          this.suspendReason = ""
        },
        (error) => {
          this.$notify.error({message: "Error saving data", timeOut: 5000})
          this.controls.showRemove = true
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })

    },
    reinstate() {
      this.$store.dispatch("setExecuting", true)
      api.post("/member/reinstate/" + this.group.vanityPath + "/?member=" + this.currentMember.id, {}).then(
        (results) => {
          this.currentMember.status = "Active"
          this.currentMember.suspendReason = null
        },
        (error) => {
          this.$notify.error({message: "Error saving data", timeOut: 5000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })

    },
    unban() {
      this.$store.dispatch("setExecuting", true)
      api.post("/member/unBan/" + this.group.vanityPath + "/?member=" + this.currentMember.id, {}).then(
        (results) => {
          this.currentMember.status = "Active"
        },
        (error) => {
          this.$notify.error({message: "Error saving data", timeOut: 5000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })

    },
    approve() {
      this.$store.dispatch("setExecuting", true)
      api.post("/member/approve/" + this.group.vanityPath + "/?member=" + this.currentMember.id, {}).then(
        (results) => {
          this.currentMember.status = "Active"
        },
        (error) => {
          this.$notify.error({message: "Error saving data", timeOut: 5000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })

    },
    deny() {
      this.$store.dispatch("setExecuting", true)
      api.post("/member/deny/" + this.group.vanityPath + "/?member=" + this.currentMember.id, {denyReason: this.denyReason}).then(
        (results) => {
          this.currentMember.status = "Denied"
          this.currentMember.denyReason = this.denyReason
        },
        (error) => {
          this.$notify.error({message: "Error saving data", timeOut: 5000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })

    },
    editNotes() {
      this.workingEdit = this.memberNotes
      this.controls.showNotes = true
    },
    cancelNotes() {
      this.controls.showNotes = false
      this.workingEdit = null
    },
    saveNotes() {
      this.controls.showNotes = false
      this.$store.dispatch("setExecuting", true)
      api.post("/member/notes/" + this.group.vanityPath + "/?member=" + this.currentMember.id, {notes: this.workingEdit}).then(
        (results) => {
          this.memberNotes = this.workingEdit
          this.workingEdit = null
        },
        (error) => {
          this.$notify.error({message: "Error saving data", timeOut: 5000})
          this.controls.showNotes = true
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })

    },
    billing() {

    },
    repRules() {
      if (!this.reputationRules) {
        this.$store.dispatch("setExecuting", true)
        api.get("/group/repRules/" + this.group.vanityPath).then(
          (results) => {
            this.reputationRules = results.data
            this.showReputationModal = true
          },
          (error) => {
            this.$notify.error({message: "Error saving data", timeOut: 5000})
            this.controls.showNotes = true
          }).then(() => {
          this.$store.dispatch("setExecuting", false)
        })
      } else {
        this.showReputationModal = true
      }
    },
    showList() {
      if (this.$route.params.member) {
        //at some point members-new will become members and we will forget to change this. :-)
        let page = "/members"
        if (this.$route.path.indexOf("members-new") >= 0) page = "/members-new"
        this.$router.replace("/group/" + this.$route.params.id + page)
        return
      }
      this.controls.showMemberDetail = false
      this.controls.showMemberList = true
      this.currentMember = null
      this.memberNotes = null
      this.$nextTick().then(() => {
        window.scrollTo(0, this.controls.listScrollPos)
      })
    },
    memberDetails(member) {
      this.showPrivateMessage = false
      this.access = []
      this.controls.showMemberList = false
      this.controls.showMemberDetail = true
      this.togetherEvents = []
      this.$nextTick().then(() => {
        window.scrollTo(0, 0)
      })
      this.$store.dispatch("setExecuting", true)
      api.get("/member/details/" + member.id).then(
        (results) => {
          this.currentMember = results.data
          this.$store.dispatch("setExecuting", false)
        },
        (error) => {
          this.$store.dispatch("setExecuting", false)
          this.$notify.error({message: "Error loading member data. " + error.response.data, timeOut: 5000})
        }
      )

      api.get("/member/togetherEvents/" + this.group.vanityPath + "?member=" + member.id).then(
        (results) => {
          this.togetherEvents = results.data.events
          this.togetherCount = results.data.togetherCount
        },
        (error) => {

        }
      )

      api.get("/conversation/validateUser/" + member.userId).then(
        () => {
          this.showPrivateMessage = true
        },
        (error) => {
          console.log("No PM allowed.", error.response.data)
        }
      )


      if (this.group.permissions.includes('Member Notes')) {
        this.memberNotes = null
        api.get("/member/notes/" + this.group.vanityPath + "?member=" + member.id).then(
          (results) => {
            this.memberNotes = results.data.notes
          },
          (error) => {

          }
        )
      }
    },

  }
};
</script>

<style scoped>
p {
  line-height: 1em;
  margin-bottom: 5px;
}

.profile-card {
  margin-top: 100px;
}

.profile-card .avatar {
  max-width: 150px;
  max-height: 150px;
  margin: -70px auto 0;
  -webkit-border-radius: 50%;
  border-radius: 50%;
  overflow: hidden;
}

.cascading-admin-card .admin-up {
  margin-left: 4%;
  margin-right: 4%;
  margin-top: -20px;
}

.cascading-admin-card .admin-up .fa {
  padding: 1.7rem;
  font-size: 2rem;
  color: #fff;
  text-align: left;
  margin-right: 1rem;
  -webkit-border-radius: 3px;
  border-radius: 3px;
}

.cascading-admin-card .admin-up .fa, .z-depth-2 {
  -webkit-box-shadow: 0 8px 17px 0 rgba(0, 0, 0, .2), 0 6px 20px 0 rgba(0, 0, 0, .19);
  box-shadow: 0 8px 17px 0 rgba(0, 0, 0, .2), 0 6px 20px 0 rgba(0, 0, 0, .19);
}

.material-input {
  box-sizing: content-box;
  background-color: transparent;
  border: none;
  border-bottom: 1px solid #ced4da;
  border-radious: 0;
  outline: none;
  box-shadow: none;
}

.list-title-header {
  position: relative;
}

.list-title-tools {
  position: absolute;
  right: 0;
  top: 0;
  padding-right: 10px;
}

.button-fixed-width {
  width: 75%;
}
</style>
<style lang="scss">
@import '~vue-datetime/dist/vue-datetime.min';

</style>

